<template>
  <div class="page admin-page">
    <div class="top-bar"></div>
    <div class="bg-decoration bg-decoration-1"></div>
    <div class="bg-decoration bg-decoration-2"></div>
    <div class="bg-decoration bg-decoration-3"></div>

    <div class="container">
      <div class="header">
        <div>
          <p class="eyebrow">后台管理系统</p>
          <h1>舆情培训系统</h1>
          <p class="subtitle">案例、视频、考试、学员统一管理</p>
        </div>
        <div class="header-right">
          <span class="user-info">👤 {{ currentUser.realName || '加载中...' }}</span>
          <button class="logout-btn" @click="logout">退出登录</button>
        </div>
      </div>

      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-value">{{ stats.cases || 0 }}</div>
          <div class="stat-label">案例总数</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ stats.videos || 0 }}</div>
          <div class="stat-label">视频总数</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ stats.exams || 0 }}</div>
          <div class="stat-label">考试次数</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ stats.students || 0 }}</div>
          <div class="stat-label">学员人数</div>
        </div>
      </div>

      <div class="menu-grid">
        <div class="menu-card" @click="goTo('/cases')">
          <div class="card-icon">📚</div>
          <div class="card-title">案例管理</div>
          <div class="card-desc">管理培训案例，配置视频、问题、标准答案</div>
          <div class="card-arrow">→</div>
        </div>

        <div class="menu-card" @click="goTo('/videos')">
          <div class="card-icon">🎬</div>
          <div class="card-title">视频管理</div>
          <div class="card-desc">上传考试视频，配置播放顺序、类型、触发时间</div>
          <div class="card-arrow">→</div>
        </div>

        <div class="menu-card" @click="goTo('/exams')">
          <div class="card-icon">📊</div>
          <div class="card-title">考试管理</div>
          <div class="card-desc">查看考试记录，管理学员考试</div>
          <div class="card-arrow">→</div>
        </div>

        <div class="menu-card" @click="goTo('/students')">
          <div class="card-icon">👨🎓</div>
          <div class="card-title">学员管理</div>
          <div class="card-desc">管理学员账号，分配培训案例</div>
          <div class="card-arrow">→</div>
        </div>
      </div>

      <div class="footer">© 2026 舆情培训系统 v1.0 | 后台管理</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      stats: {
        cases: 0,
        videos: 0,
        exams: 0,
        students: 0
      }
    }
  },
  mounted() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      try {
        const casesRes = await axios.get('/api/cases')
        this.stats.cases = this.unwrapList(casesRes.data).length

        const videosRes = await axios.get('/api/videos/stats/all')
        this.stats.videos = this.unwrapList(videosRes.data).length

        const examsRes = await axios.get('/api/exams/all')
        this.stats.exams = this.unwrapList(examsRes.data).length

        const studentsRes = await axios.get('/api/auth/users')
        this.stats.students = this.unwrapList(studentsRes.data).filter(user => user.role !== 'ADMIN').length
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },
    unwrapList(response) {
      if (Array.isArray(response)) return response
      if (response && Array.isArray(response.data)) return response.data
      return []
    },
    goTo(path) {
      this.$router.push(path)
    },
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.removeItem('userInfo')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.admin-page {
  min-height: 100vh;
  position: relative;
  padding: 20px;
}

.top-bar {
  position: fixed;
  inset: 0 0 auto 0;
  height: 6px;
  background: linear-gradient(90deg, #3B82F6, #06B6D4, #10B981);
  z-index: 2;
}

.bg-decoration {
  position: fixed;
  border-radius: 50%;
  opacity: 0.07;
  pointer-events: none;
}

.bg-decoration-1 {
  width: 380px;
  height: 380px;
  background: #3B82F6;
  top: -120px;
  right: -110px;
}

.bg-decoration-2 {
  width: 280px;
  height: 280px;
  background: #06B6D4;
  bottom: -90px;
  left: -90px;
}

.bg-decoration-3 {
  width: 180px;
  height: 180px;
  background: #10B981;
  top: 48%;
  left: 12%;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 24px 28px;
  margin-bottom: 28px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(59, 130, 246, 0.12);
  backdrop-filter: blur(16px);
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(16, 35, 58, 0.08);
}

.eyebrow {
  margin-bottom: 8px;
  color: #3B82F6;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #10233a;
}

.subtitle {
  margin-top: 6px;
  color: #5b6b7d;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info {
  color: #5b6b7d;
  font-size: 14px;
}

.logout-btn {
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #2563eb;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 10px;
  cursor: pointer;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  padding: 22px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(59, 130, 246, 0.12);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(16, 35, 58, 0.06);
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #1f4bd8;
  line-height: 1;
}

.stat-label {
  margin-top: 8px;
  color: #6b7c90;
  font-size: 14px;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.menu-card {
  position: relative;
  padding: 22px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(59, 130, 246, 0.12);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(16, 35, 58, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.menu-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 34px rgba(16, 35, 58, 0.1);
}

.card-icon {
  font-size: 28px;
  margin-bottom: 14px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #10233a;
}

.card-desc {
  margin-top: 10px;
  color: #5b6b7d;
  line-height: 1.6;
}

.card-arrow {
  position: absolute;
  right: 18px;
  bottom: 16px;
  color: #3B82F6;
  font-size: 20px;
}

.footer {
  padding: 10px 4px 0;
  color: #718096;
  text-align: center;
  font-size: 13px;
}

@media (max-width: 960px) {
  .stats-grid,
  .menu-grid {
    grid-template-columns: 1fr 1fr;
  }

  .header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .stats-grid,
  .menu-grid {
    grid-template-columns: 1fr;
  }

  .admin-page {
    padding: 14px;
  }
}
</style>
